const Preloader = () => {
  return (
    <div id="preloader">
      <div id="container" className="container-preloader">
        <div className="animation-preloader">
          {/* <div className="spinner" > */}
          <img src="/assets/imgs/logo/loader.svg" alt="Loading..." />
          {/* </div> */}
        </div>
        <div className="loader-section section-left" />
        <div className="loader-section section-right" />
      </div>
    </div>
  );
};

export default Preloader;